import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Typography, LinearProgress } from '@homeviews/shared-ui'
import type { Rating } from '@homeviews/models'

import { getRatingChangeMeta } from '../../../index'

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      marginBottom: 12,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: '-0.2px',
      lineHeight: '18px',
      width: 100,
    },
    value: {
      fontSize: 13,
      fontWeight: 500,
      letterSpacing: '0.22px',
      lineHeight: '16px',
      marginLeft: 12,
    },
    diff: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '15px',
      width: 100,
      marginLeft: 5,
    },
  }),
)

const RATINGS_LABELS = {
  1: 'Very Poor',
  2: 'Disappointing',
  3: 'Average',
  4: 'Very Good',
  5: 'Excellent',
}

interface IProps {
  className?: string
  ratings: Rating[]
  statsPeriod?: string
}

const RatingsBreakdown: FC<IProps> = ({ className, ratings, statsPeriod }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      {!!ratings &&
        Object.keys(ratings)?.length &&
        Object.keys(ratings)
          .reverse()
          .map((key: string) => {
            const rating: Rating = ratings[key]
            const { diffText, diffCssClass } = getRatingChangeMeta(
              rating.pct_change,
              statsPeriod,
              '%',
            )
            return (
              <div className={classes.item} key={key}>
                <Typography className={classes.label}>
                  {RATINGS_LABELS?.[key] || ''}
                </Typography>
                <LinearProgress value={rating.value} />
                <Typography className={classes.value}>
                  {rating.value}%
                </Typography>
                <Typography className={clsx(classes.diff, diffCssClass)}>
                  {diffText}
                </Typography>
              </div>
            )
          })}
    </div>
  )
}

export default RatingsBreakdown
